import { HttpClient } from '@packages/utils/HttpClient';
import { Pagination } from './PaginationHandler';
import ToastNotification from './ToastNotification';
import parseErrorMessage from './ErrorParser';

const CustomHttpClient = HttpClient;

export interface Metadata {
    pagination: Pagination;
}

// Axios response interceptor...
CustomHttpClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error && error.response)
            ToastNotification({
                type: 'error',
                message: 'Error',
                description: parseErrorMessage(error.response.data),
            });
        return Promise.reject(error);
    },
);

export default CustomHttpClient;
